import React, { useState } from "react";
import CartModal from "../../Components/CartModal";
import { useCart } from "../../Contexts/CartContext";
import ReplacementPumpCassettonlysuitableforpHControllerorM3M4Peripods from "../../Assets/Replacement Pump Cassette - only suitable for pH Controller or M3 or M4 Peripods.webp";
import "bootstrap/dist/css/bootstrap.min.css"; // Import Bootstrap CSS

const Replacement_Pump_Cassette = () => {
  const [showModal, setShowModal] = useState(false);
  const { addToCart } = useCart();

  const handleAddToCart = () => {
    const product = {
      id: 28,
      name: "Replacement Pump Cassette - only suitable for pH Controller or M3/M4 Peripods",
      price: 5712,
      image: ReplacementPumpCassettonlysuitableforpHControllerorM3M4Peripods,
    };
    addToCart({ ...product, quantity: 1 });
    setShowModal(true);
  };

  return (
    <div className="container mt-3">
      {" "}
      {/* Add margin top to the container */}
      <div className="row">
        <div className="col-md-6">
          <div
            id="productCarousel"
            className="carousel slide"
            data-ride="carousel"
          >
            <div className="carousel-inner">
              <div className="carousel-item active">
                <img
                  src={
                    ReplacementPumpCassettonlysuitableforpHControllerorM3M4Peripods
                  }
                  alt="Product 1"
                  className="d-block w-100"
                />
              </div>
              {/* Add more images to the carousel as needed */}
            </div>
            <a
              className="carousel-control-prev"
              href="#productCarousel"
              role="button"
              data-slide="prev"
            >
              <span
                className="carousel-control-prev-icon"
                aria-hidden="true"
              ></span>
              <span className="sr-only">Previous</span>
            </a>
            <a
              className="carousel-control-next"
              href="#productCarousel"
              role="button"
              data-slide="next"
            >
              <span
                className="carousel-control-next-icon"
                aria-hidden="true"
              ></span>
              <span className="sr-only">Next</span>
            </a>
          </div>
        </div>

        <div className="col-md-6">
          <div className="product-details">
            <h2 className="product-name">
              Replacement Pump Cassette - only suitable for pH Controller or
              M3/M4 Peripods
            </h2>
            <p className="product-price">₹{5712}</p>
            <button className="btn btn-primary" onClick={handleAddToCart}>
              Add to Cart
            </button>
            <p className="product-description mt-3 text-justify">
              The Replacement Pump Cassette is designed specifically for use
              with the Bluelab pH Controller and M3/M4 Peripods. It's easy to
              install, ensuring seamless maintenance and optimal dosing
              performance.
              <h5 className="mt-3">Product Features</h5>
              <ul>
                <li>All-in-one unit with integrated rollers and internal tubing</li>
                <li>Quick and easy replacement: just unscrew the pump cover and twist to remove the cassette from the drive motor</li>
                <li>Fully compatible with Bluelab pH Controller, as well as Bluelab PeriPod M3 and M4 models</li>
              </ul>
            </p>
          </div>
        </div>
      </div>
      {/* Conditionally render the CartModal based on showModal */}
      {showModal && <CartModal onClose={() => setShowModal(false)} />}
    </div>
  );
};

export default Replacement_Pump_Cassette;
